import { lazy } from 'react'
import PayRunsLoader from './pay-runs/loader'
import EditPayRunLoader from './pay-runs/edit/loader'
import PaySummaryLoader from './pay-summary/loader'

export default {
  PaySummary: {
    Component: lazy(() => import('./pay-summary/PaySummary.Page')),
    Loader: PaySummaryLoader,
  },
  PayRuns: {
    Component: lazy(() => import('./pay-runs/PayRuns.Page')),
    Loader: PayRunsLoader,

    Edit: {
      Component: lazy(() => import('./pay-runs/edit/EditPayRun.Page')),
      Loader: EditPayRunLoader,
    },
  },
}
